import { useIsAuthenticated } from '@heidi/auth/state';
import { useQuery } from '@tanstack/react-query';
import {
  COMMUNITY_TEMPLATE_BATCH_LIKE_STATUS_KEY,
  COMMUNITY_TEMPLATE_LIKE_STATUS_KEY,
} from '../../contracts';
import { getBatchLikeStatus, getLikeStatus } from '../api/templates';

export function useQueryCommunityTemplateLikeStatus(templateId: string) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [COMMUNITY_TEMPLATE_LIKE_STATUS_KEY, templateId],
    queryFn: async () => {
      const { data } = await getLikeStatus(templateId);
      return data;
    },
    enabled: isAuthenticated && !!templateId,
  });
}

export function useQueryCommunityTemplateBatchLikeStatus(templateIds: string[]) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [COMMUNITY_TEMPLATE_BATCH_LIKE_STATUS_KEY, templateIds],
    queryFn: async () => {
      if (templateIds.length === 0) {
        return { statuses: {} };
      }
      const { data } = await getBatchLikeStatus(templateIds);
      return data;
    },
    enabled: isAuthenticated && templateIds.length > 0,
  });
}
